import React from 'react';
import { SectionHeader, Typography } from 'web-library';

const ReviewPayLabel = () => (
  <>
    <SectionHeader title="Review candidate registration details" />

    <Typography variant="body1">
      {`${"Please review this candidate's registration details."}`}
    </Typography>
  </>
);

export default ReviewPayLabel;
